export default __webpack_public_path__ + "static/media/veggies.394c913a.png";